module.exports = __webpack_public_path__ + "img/jionEmail.33b5b806.png";